var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bto-sb-message",class:[`bto-sb-message-${_vm.type}`],on:{"click":function($event){return _vm.$emit('click')}}},[_c('p',[_vm._v(_vm._s(_vm.t(_vm.message)))]),(_vm.subMessages && _vm.subMessages.length > 0)?_c('ul',_vm._l((_vm.subMessages),function(msg,i){return _c('li',{key:i},[_vm._v(_vm._s(_vm.t(msg)))])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }